//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type

import com.apollographql.apollo.api.Optional
import com.apollographql.apollo.api.Upload
import kotlin.Any
import kotlin.Int
import kotlin.String

public data class FileUploadCommandInput(
  public val id: Any,
  public val fileName: String,
  public val chunk: Upload,
  public val chunkIndex: Int,
  public val totalChunks: Int,
  public val fileCategory: FileCategory,
  public val bunkerActivityDocumentType: Optional<BunkerActivityDocumentType?> = Optional.Absent,
)
